export function getThumbnailUrl(imageUrl: string, video?: boolean): string {
  const search = 'images%2F';
  let url: string;
  if (imageUrl) {
    if (video) {
      url = (imageUrl).replace(search, `${search}thumb@256_`);
      url = url.replace('.mp4', '.mp4.gif');
      url = url.replace('.webm', '.webm.gif');
    } else {
      url = (imageUrl).replace(search, `${search}thumb@256_`);
    }
  }
  return url;
}
